import React, { useState, useEffect } from 'react';
function ImageResolutionSimple({ resolution, onResolutionChange }) {
    const [resolutions, setResolutions] = useState(commonResolutions);
    const [customWidth, setCustomWidth] = useState(resolution.width);
    const [customHeight, setCustomHeight] = useState(resolution.height);
    const findMatchingResolution = (width, height) => {
        const match = resolutions.find(r => r.width === width && r.height === height && r.value !== 'custom');
        return match ? match.value : 'custom';
    };
    const [selectedResolution, setSelectedResolution] = useState(() => findMatchingResolution(resolution.width, resolution.height));
    useEffect(() => {
        const matchedValue = findMatchingResolution(resolution.width, resolution.height);
        setSelectedResolution(matchedValue);
        setCustomWidth(resolution.width);
        setCustomHeight(resolution.height);
    }, [resolution.width, resolution.height]);
    const handleResolutionChange = (event) => {
        const value = event.target.value;
        setSelectedResolution(value);
        if (value === 'custom') {
            onResolutionChange(customWidth, customHeight);
        }
        else {
            const res = resolutions.find(r => r.value === value);
            if (!res)
                return;
            setCustomWidth(res.width);
            setCustomHeight(res.height);
            onResolutionChange(res.width, res.height);
        }
    };
    const handleCustomWidthChange = (event) => {
        const value = parseInt(event.target.value) || 1024;
        setCustomWidth(value);
    };
    const handleCustomHeightChange = (event) => {
        const value = parseInt(event.target.value) || 1024;
        setCustomHeight(value);
    };
    const handleCustomWidthBlur = () => onResolutionChange(customWidth, customHeight);
    const handleCustomHeightBlur = () => onResolutionChange(customWidth, customHeight);
    return (React.createElement("div", null,
        React.createElement("label", { htmlFor: "resolutionSelect", className: "form-label" }, "Select Resolution:"),
        React.createElement("select", { id: "resolutionSelect", className: "form-select", value: selectedResolution, onChange: handleResolutionChange }, resolutions.map((resolution) => (resolution.value === 'custom'
            ? (React.createElement("option", { key: resolution.value, value: resolution.value }, resolution.label))
            : (React.createElement("option", { key: resolution.value, value: resolution.value },
                resolution.label,
                " (",
                resolution.width,
                "x",
                resolution.height,
                ")"))))),
        selectedResolution === 'custom' && (React.createElement("div", { className: "row mb-3" },
            React.createElement("div", { className: "col-md-6" },
                React.createElement("label", { htmlFor: "customWidth", className: "form-label" }, "Width (px):"),
                React.createElement("input", { type: "number", id: "customWidth", className: "form-control", value: customWidth, onChange: handleCustomWidthChange, onBlur: handleCustomWidthBlur, min: "1", max: "10000" })),
            React.createElement("div", { className: "col-md-6" },
                React.createElement("label", { htmlFor: "customHeight", className: "form-label" }, "Height (px):"),
                React.createElement("input", { type: "number", id: "customHeight", className: "form-control", value: customHeight, onChange: handleCustomHeightChange, onBlur: handleCustomHeightBlur, min: "1", max: "10000" }))))));
}
const commonResolutions = [
    { label: '1080p landscape (Full HD)', width: 1920, height: 1080, value: 'full-hd-landscape' },
    { label: '1080p portrait (Full HD)', width: 1080, height: 1920, value: 'full-hd-portrait' },
    { label: '768p landscape (HD)', width: 1366, height: 768, value: 'hd-landscape' },
    { label: '768p portrait (HD)', width: 768, height: 1366, value: 'hd-portrait' },
    { label: '720p landscape', width: 1280, height: 720, value: '720p-landscape' },
    { label: '720p portrait', width: 720, height: 1280, value: '720p-portrait' },
    { label: '480p landscape', width: 854, height: 480, value: '480p-landscape' },
    { label: '480p portrait', width: 480, height: 854, value: '480p-portrait' },
    { label: '360p landscape', width: 640, height: 360, value: '360p-landscape' },
    { label: '360p portrait', width: 360, height: 640, value: '360p-portrait' },
    { label: '240p landscape', width: 426, height: 240, value: '240p-landscape' },
    { label: '240p portrait', width: 240, height: 426, value: '240p-portrait' },
    { label: '1440p landscape (QHD)', width: 2560, height: 1440, value: 'qhd-landscape' },
    { label: '1440p portrait (QHD)', width: 1440, height: 2560, value: 'qhd-portrait' },
    { label: '2K landscape (Cinema)', width: 2048, height: 1080, value: '2k-landscape' },
    { label: '2k portrait (Cinema)', width: 1080, height: 2048, value: '2k-portrait' },
    { label: '4K landscape (UHD)', width: 3840, height: 2160, value: '4k-uhd-landscape' },
    { label: '4k portrait (UHD)', width: 2160, height: 3840, value: '4k-uhd-portrait' },
    { label: '4K landscape (Cinema)', width: 4096, height: 2160, value: '4k-cinema-landscape' },
    { label: '4k portrait (Cinema)', width: 2160, height: 4096, value: '4k-cinema-portrait' },
    { label: '8K landscape (UHD-2)', width: 7680, height: 4320, value: '8k-landscape' },
    { label: '8k portrait (UHD-2)', width: 4320, height: 7680, value: '8k-portrait' },
    { label: 'Instagram Square Post', width: 1080, height: 1080, value: 'instagram-square' },
    { label: 'Instagram Story', width: 1080, height: 1920, value: 'instagram-story' },
    { label: 'Facebook Cover Photo', width: 1200, height: 630, value: 'facebook-cover' },
    { label: 'Facebook Post', width: 1200, height: 630, value: 'facebook-post' },
    { label: 'X/Twitter Header', width: 1500, height: 500, value: 'twitter-header' },
    { label: 'X/Twitter Post', width: 1200, height: 675, value: 'twitter-post' },
    { label: 'LinkedIn Cover', width: 1584, height: 396, value: 'linkedin-cover' },
    { label: 'LinkedIn Post', width: 1200, height: 627, value: 'linkedin-post' },
    { label: 'YouTube Thumbnail', width: 1280, height: 720, value: 'youtube-thumbnail' },
    { label: 'YouTube Banner', width: 2560, height: 1440, value: 'youtube-banner' },
    { label: 'TikTok Video', width: 1080, height: 1920, value: 'tiktok-video' },
    { label: 'Pinterest Pin', width: 1000, height: 1500, value: 'pinterest-pin' },
    { label: 'VGA', width: 640, height: 480, value: '640' },
    { label: 'SVGA', width: 800, height: 600, value: '800' },
    { label: 'XGA', width: 1024, height: 768, value: '768' },
    { label: 'SXGA', width: 1280, height: 1024, value: '1280' },
    { label: '1024 square', width: 1024, height: 1024, value: '1024' },
    { label: '512 square', width: 512, height: 512, value: '512' },
    { label: '256 square', width: 256, height: 256, value: '256' },
    { label: '128 square', width: 128, height: 128, value: '128' },
    { label: '96 square', width: 96, height: 96, value: '96' },
    { label: '64 square', width: 64, height: 64, value: '64' },
    { label: '32 square', width: 32, height: 32, value: '32' },
    { label: '24 square', width: 24, height: 24, value: '24' },
    { label: '16 square', width: 16, height: 16, value: '16' },
    { label: 'Custom Resolution', width: 1024, height: 1024, value: 'custom' }
];
export default ImageResolutionSimple;
